module.exports = __webpack_public_path__ + "media/images/iconSocialFacebook__okGreen--dark-0308c2b55c6b32b2cc0e37fdbbc84847.png";